<template>
  <div>
    <page-header
      left-side-class="col-xl-4"
      :page="pageConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    >
      <div style="display: flex;">
        <action-button
          i="fas fa-arrow-circle-left"
          variant="success"
          @click="$router.go(-1)"
        >
          Regresar
        </action-button>

        <action-button
          v-if="isProvisionalRemedy"
          i="fas fa-print"
          variant="outline-success ml-2"
          @click="handleDownloadReportRP"
        >
          Imprimir Propuesta
        </action-button>

        <action-button
          v-if="canResetDetermination && !showDetermination"
          id="btnResetDetermination"
          i="fas fa-undo"
          variant="success ml-2"
          @click="onResetDeterminationHandler"
        >
          Regresar Determinación
        </action-button>
        <div
          v-if="canDetermineProposalRequest && !showDetermination"
          class="dropdown ml-2"
        >
          <button
            v-if="canDetermineProposalRequest"
            aria-expanded="false"
            aria-haspopup="true"
            class="btn btn-dropdown-actions w-100 dropdown-toggle float-left color-white bg-green font-weight-bold d-flex justify-content-center align-items-center mr-2 px-2"
            data-toggle="dropdown"
            type="button"
          >
            <i class="fas fa-flag-alt mx-2 pr-1 mt-2" />
            <span class="mr-1">Determinar</span>
          </button>
          <div
            aria-labelledby="dropdownMenuButton"
            class="dropdown-menu dropdown-menu-right custom-dropdown-container"
          >
            <div
              v-if="canRecommendProposalRequest"
              class="dropdown-item cursor-pointer mb-1"
              @click="
                onOpenDeterminationHandler(
                  proposalRequestStatusEnum.Recommendation
                )
              "
            >
              <i class="fas fa-check text-green mr-2" />
              Recomendar
            </div>
            <div
              v-if="
                isProvisionalRemedy &&
                  canRecommendProposalRequest &&
                  information.statusId !=
                    proposalRequestStatusEnum.PartialRecommendation
              "
              class="dropdown-item cursor-pointer mb-1"
              @click="
                onOpenDeterminationHandler(
                  proposalRequestStatusEnum.PartialRecommendation
                )
              "
            >
              <i class="fas fa-check text-yellow mr-2" />
              Recomendado Parcial
            </div>
            <div
              v-if="canNotRecommendProposalRequest"
              class="dropdown-item cursor-pointer mb-1"
              @click="
                onOpenDeterminationHandler(
                  proposalRequestStatusEnum.Not_Recommendation
                )
              "
            >
              <i class="fas fa-times-circle text-red mr-2" />
              No Recomienda
            </div>
            <div
              v-if="isProvisionalRemedy"
              class="dropdown-item cursor-pointer mb-1"
              @click="
                onOpenDeterminationHandler(
                  proposalRequestStatusEnum.RequirementsDoesNotAccomplish
                )
              "
            >
              <i class="fas fa-times-circle text-red mr-2" />
              No Cumple Requisitos
            </div>
          </div>
        </div>
      </div>
    </page-header>
    <proposal-request-determination
      v-if="showDetermination"
      class="mb-3"
      :determination-status-id="determinationStatusId"
      :is-for-reset-determination="isForResetDetermination"
      :proposal-request-id="proponentProfileId"
      :proposal-request-number="information.proposalNumber"
      @on-cancel="onCancelDeterminationHandler"
      @saved="onSavedDeterminationHandler"
    />
    <board class="mb-4" :details="board" />

    <custom-tab content-class="mt-3" :no-nav-style="true">
      <custom-tab-item :active="true" lazy title="Perfil Proponente">
        <general-information
          :data="information"
          :is-professional-services="isProfessionalServices"
          :is-provisional-remedy-area="isProvisionalRemedy"
        />
        <geographic-areas
          v-if="isProvisionalRemedy || isProfessionalServices"
          :items="information.serviceCenters"
        />
        <provided-services
          v-if="isProvisionalRemedy"
          :evaluations="information.aditionalEvaluationServices"
          :therapies="information.therapyServices"
        />
        <proposal-request-documents
          :can-delete-document="canDetermineProposalRequest"
          :documents="documents"
          @donwload="downloadDocument"
          @view="viewDocument"
        />
      </custom-tab-item>
      <custom-tab-item
        v-if="isProvisionalRemedy"
        lazy
        title="Detalles de la Propuesta"
      >
        <proposal-details :proposal-request-id="proponentProfileId" />
      </custom-tab-item>
      <custom-tab-item lazy title="Historial">
        <proposal-request-status-history
          ref="proposalStatusHistoryRef"
          :proposal-request-id="proponentProfileId"
        />
      </custom-tab-item>
      <custom-tab-item v-if="canDocumentAccess" lazy :title="documentsTabTitle">
        <proposal-determination-documents
          :is-provisional-remedy-area="isProvisionalRemedy"
        />
      </custom-tab-item>
      <custom-tab-item v-if="isProvisionalRemedy" lazy title="Bitácora">
        <bitacora-manager />
      </custom-tab-item>
    </custom-tab>
  </div>
</template>

<script>
import Board from 'Board';
import PageHeader from 'PageHeader';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import _generalApi from '@/modules/app/api';
import {
  getDetail as _getDetail,
  getProposalRequestDocument as _getProposalRequestDocument,
  getProposalDeterminationDocuments as _getProposalDeterminationDocuments,
} from '@/modules/proposalProcess/api.js';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import { emptyFilter } from '@/filters';

import {
  GeneralInformation,
  ProposalRequestDocuments,
  GeographicAreas,
  ProvidedServices,
  ProposalDetails,
  BitacoraManager,
} from './components';

import ProposalDeterminationDocuments from './components/DeterminationDocuments/Main.vue';
import ProposalRequestDetermination from './components/ProposalRequestDetermination.vue';
import ProposalRequestStatusHistory from './components/ProposalRequestStatusHistory';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//constants
import { proposalRequestStatus as proposalRequestStatusEnum } from '@/utils/constants/proposalRequestStatus';
import proposalRequestStatus from '@/utils/shared/constants/proposalStatus.js';
import proposalArea from '@/utils/shared/constants/proposalArea.js';
import sysparameterByNames from '@/utils/constants/sysParameterNames';

const PERMISSION_DOCUMENTS_ACCESS =
  'provider.proposal.determination.documents.tab';
const DOCUMENT_VIEWER_ROUTE_NAME = 'DocumentViewer';

const STATUS_HAS_DETERMINATION_DOCUMENT = [
  proposalRequestStatusEnum.NotRecommended,
  proposalRequestStatusEnum.Recommended,
];

export default {
  name: 'ProponentProfile',
  components: {
    PageHeader,
    Board,
    CustomTab,
    CustomTabItem,
    GeneralInformation,
    ProposalDeterminationDocuments,
    ProposalRequestDocuments,
    ProposalRequestDetermination,
    ProposalRequestStatusHistory,
    GeographicAreas,
    ProvidedServices,
    ProposalDetails,
    BitacoraManager,
  },
  mixins: [alertMixin],
  data() {
    return {
      sysParameters: { ProvisionalRemedyProposalDocumentRequired: {} },
      information: {},
      determinationStatusId: null,
      showDetermination: null,
      isForResetDetermination: false,
    };
  },
  computed: {
    isProvisionalRemedy() {
      return this.information.areaId == proposalArea.ProvisionalRemedy;
    },
    isProfessionalServices() {
      return this.information.areaId == proposalArea.ProfessionalServices;
    },
    provisionalRemedyDocumentRequired() {
      const {
        staticValue = 'false',
      } = this.sysParameters.ProvisionalRemedyProposalDocumentRequired;
      return JSON.parse(staticValue.toLowerCase());
    },
    canDocumentAccess() {
      return (
        this.isProvisionalRemedy ||
        (this.userHasPermissions(PERMISSION_DOCUMENTS_ACCESS) &&
          STATUS_HAS_DETERMINATION_DOCUMENT.includes(
            this.information?.statusId
          ))
      );
    },
    board() {
      return [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-calendar-edit ',
            data: emptyFilter(this.information?.fiscalYearName),
            cols: 'col col-sm col-12',
          },
          {
            label: 'Numero de Aviso:',
            icon: 'fas fa-file-spreadsheet',
            data: emptyFilter(this.information?.announcementNumber),
            cols: 'col col-sm col-12',
          },
          {
            label: 'Numero de Propuesta:',
            icon: 'fas fa-file-invoice',
            data: emptyFilter(this.information?.proposalNumber),
            cols: 'col col-sm col-12',
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-file-exclamation',
            data: emptyFilter(this.information?.statusDescription),
            cols: 'col col-sm col-12',
          },
        ],
      ];
    },
    pageConfig() {
      return {
        icon: 'fas fa-user',
        title: 'Perfil del Proponente',
        routes: ['Proveedor', 'Proceso de Competencias', 'Ver'],
      };
    },
    canDetermineProposalRequest() {
      return (
        [
          proposalRequestStatus.Submitted,
          proposalRequestStatus.PartialRecommendation,
        ].includes(this.information.statusId) &&
        this.userHasPermissions('provider.proposal.determination.infra.view')
      );
    },
    canRecommendProposalRequest() {
      return this.userHasPermissions(
        'provider.proposal.determination.infra.recommended.view'
      );
    },
    canNotRecommendProposalRequest() {
      return this.userHasPermissions(
        'provider.proposal.determination.infra.notrecommended.view'
      );
    },
    proponentProfileId() {
      return this.$route.params.id ? Number(this.$route.params.id) : 0;
    },
    documents() {
      return this.information?.documents ?? [];
    },
    documentsTabTitle() {
      return this.isProvisionalRemedy
        ? 'Documentos de Respaldo'
        : 'Documentos de Determinación';
    },
    proposalRequestStatusEnum() {
      return proposalRequestStatus;
    },
    canResetDetermination() {
      return (
        [
          proposalRequestStatus.Recommendation,
          proposalRequestStatus.Not_Recommendation,
          proposalRequestStatus.RequirementsDoesNotAccomplish,
        ].includes(this.information?.statusId) &&
        this.isProvisionalRemedy &&
        this.userHasPermissions(
          'provider.proposal.determination.infra.reset.view'
        )
      );
    },
  },
  async mounted() {
    await this.getGeneralInformation();
    await this.getParameters();
  },
  methods: {
    async handleDownloadReportRP() {
      await _generalApi.getProposalRequestRP(
        this.information.proposalRequestId
      );
    },
    async getParameters() {
      const { data: sysParameters } = await _getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.ProvisionalRemedyProposalDocumentRequired,
        ],
      });
      this.sysParameters = sysParameters.reduce(
        (acc, current) => ({ ...acc, [current.name]: current }),
        this.sysParameters
      );
    },
    async getGeneralInformation() {
      const { data } = await _getDetail(this.proponentProfileId);
      this.information = data;
    },
    async downloadDocument({ documentId }) {
      const { data } = await _getProposalRequestDocument(documentId);
      _generalApi.ConvertToBlob(data);
    },
    async viewDocument({ documentId, documentName: docName }) {
      const linkData = this.$router.resolve({
        name: DOCUMENT_VIEWER_ROUTE_NAME,
        query: { documentId, docName },
      });
      window.open(linkData.href, '_blank');
    },
    async onOpenDeterminationHandler(statusId) {
      if (this.isProvisionalRemedy && this.provisionalRemedyDocumentRequired) {
        const {
          data: documents = [],
        } = await _getProposalDeterminationDocuments(
          this.information.proposalRequestId
        );
        if (!documents.length) {
          this.ShowToast(
            'Alerta',
            `Al menos un documento de respaldo es requerido para determinar la propuesta.`,
            'error'
          );
          return;
        }
      }
      this.determinationStatusId = statusId;
      this.isForResetDetermination = false;
      this.showDetermination = true;
    },
    onCancelDeterminationHandler() {
      this.determinationStatusId = null;
      this.isForResetDetermination = false;
      this.showDetermination = null;
    },
    async onSavedDeterminationHandler() {
      this.onCancelDeterminationHandler();
      await this.$refs?.proposalStatusHistoryRef?.getProposalRequestStatusHistory(); //refresh status history comp
      await this.getGeneralInformation();
    },
    onResetDeterminationHandler() {
      this.isForResetDetermination = true;
      this.showDetermination = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../scss/brand_variables.scss';

::v-deep a.nav-link.active {
  color: $orange !important;
  border-bottom: 3px solid $orange !important;
}

.text-yellow {
  color: #f8b63c;
}
</style>
